import {
  faSort,
  faEye,
  faSync,
  faBan,
  faTrash,
  faArrowLeft,
  faSave,
  faPlus,
  faPencilAlt,
  faUser,
  faTachometerAlt,
  faHeart,
  faList,
  faTasks,
  faBook,
  faHdd,
  faClock,
  faSignInAlt,
  faSignOutAlt,
  faWrench,
  faThList,
  faUserPlus,
  faAsterisk,
  faFlag,
  faBell,
  faHome,
  faTimesCircle,
  faSearch
} from '@fortawesome/fontawesome-free-solid';
import fontawesome from '@fortawesome/fontawesome';

export const loadIcons = () => {
  fontawesome.library.add(
    faSort,
    faEye,
    faSync,
    faBan,
    faTrash,
    faArrowLeft,
    faSave,
    faPlus,
    faPencilAlt,
    faUser,
    faTachometerAlt,
    faHeart,
    faList,
    faTasks,
    faBook,
    faHdd,
    faClock,
    faSignInAlt,
    faSignOutAlt,
    faWrench,
    faThList,
    faUserPlus,
    faAsterisk,
    faFlag,
    faBell,
    faHome
  );
};
